export function hasDuplicates<T>(arr: T[]): boolean {
  return new Set(arr).size < arr.length;
}

export const GLOBAL_OTHERS_KEYS = ["Autre", "Autres", "Other", "Others"];
type KeysString<T> = {
  [K in keyof T]: T[K] extends string ? K : never;
}[keyof T];

export const pushOtherToEnd = <T extends object, K extends KeysString<T>>(data: T[], key: K) => {
  const foundIndex = data.findIndex((item) =>
    typeof item[key] === "string" ? GLOBAL_OTHERS_KEYS.includes(item[key]) : false
  );

  if (foundIndex >= 0) data.push(data.splice(foundIndex, 1)[0]);
  return data;
};
